export const FOOTER_HEIGHT = 50;
